export const PDFKIT_SIGNOFF = import.meta.env.VITE_PDFKIT_SIGNOFF === 'true';

/**
 * Feature flag: Legacy PDF actions in Task Distribution.
 *
 * When `false` (default), the following UI controls are hidden:
 *
 *   Global (PreviewLauncher.tsx):
 *     - "Include posting instruction images in PDF" checkbox
 *     - "Open Print Preview (Snapshots)" button
 *     - "Open Print Preview & Mark All Sent" button
 *
 *   Per-operator (OperatorAccordion.tsx):
 *     - "Include images" checkbox
 *     - "Generate PDF" button
 *     - "Mark Sent" button (PDF-tied)
 *     - "Preview" button
 *
 * What remains visible & unaffected:
 *     - Excel export buttons (Postings + Removals, Postings Only)
 *     - "Download Cycle Kitting Workbook"
 *     - "Send to Mobile" actions
 *     - All tables and data-fetching logic
 *
 * This is a cosmetic-only change. No backend routes, PDF services, snapshot
 * generation, or data-flow behaviour has been modified. To restore the old
 * UI, simply set this flag to `true`.
 *
 * @see PreviewLauncher.tsx  — global PDF actions
 * @see OperatorAccordion.tsx — per-operator PDF actions
 * @since 2026-02-09
 */
export const SHOW_LEGACY_PDF_ACTIONS = false;
